import React, { useState } from "react";
import { motion } from "framer-motion";

export default function BarChart({
  data = [],
  labels = [],
  title,
  height = 200,
}) {
  const [hoveredBar, setHoveredBar] = useState(null);

  // Pastikan data selalu array dengan 7 elemen (untuk 7 hari)
  const chartData = data && data.length > 0 ? data : [0, 0, 0, 0, 0, 0, 0];
  const chartLabels =
    labels && labels.length > 0
      ? labels
      : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  console.log("📊 BarChart received data:", data);
  console.log("📊 BarChart chartData:", chartData);

  const max = Math.max(...chartData, 1);
  console.log("📊 BarChart max value:", max);

  return (
    <motion.div
      style={{
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "12px",
        padding: "20px",
        boxShadow:
          "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
        transition: "all 0.2s ease",
      }}
      whileHover={{
        boxShadow: "0 6px 12px rgba(0,0,0,0.08)",
        opacity: 0.98,
        transition: { duration: 0.2 },
      }}
    >
      {title && (
        <h3
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#0f172a",
            margin: 0,
            marginBottom: "20px",
          }}
        >
          {title}
        </h3>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "8px",
          height: `${height}px`,
          background: "#f8fafc",
          borderRadius: "8px",
          padding: "12px 8px 0 8px",
        }}
      >
        {chartData.map((value, idx) => {
          const percentage = value > 0 ? Math.max((value / max) * 100, 8) : 0;
          const isHovered = hoveredBar === idx;

          return (
            <div
              key={idx}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
                height: "100%",
                position: "relative",
              }}
              onMouseEnter={() => setHoveredBar(idx)}
              onMouseLeave={() => setHoveredBar(null)}
            >
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  position: "relative",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                {value > 0 && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: `${percentage}%`, opacity: 1 }}
                    transition={{
                      duration: 0.8,
                      delay: idx * 0.1,
                      ease: [0.4, 0, 0.2, 1],
                    }}
                    style={{
                      width: "100%",
                      background: "linear-gradient(to top, #3b82f6, #60a5fa)",
                      borderRadius: "6px 6px 0 0",
                      minHeight: "8px",
                      boxShadow: "0 -2px 8px rgba(59, 130, 246, 0.3)",
                      position: "relative",
                    }}
                    whileHover={{
                      background: "linear-gradient(to top, #2563eb, #3b82f6)",
                      scale: 1.05,
                    }}
                  >
                    {isHovered && (
                      <motion.div
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 8 }}
                        style={{
                          position: "absolute",
                          top: "-28px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#ffffff",
                          whiteSpace: "nowrap",
                          background: "#3b82f6",
                          padding: "4px 8px",
                          borderRadius: "6px",
                          boxShadow: "0 2px 8px rgba(59, 130, 246, 0.4)",
                        }}
                      >
                        Rp {(value * 1000).toLocaleString("id-ID")}
                      </motion.div>
                    )}
                  </motion.div>
                )}
              </div>
              <span
                style={{
                  fontSize: "11px",
                  color: value > 0 ? "#3b82f6" : "#94a3b8",
                  fontWeight: value > 0 ? "600" : "500",
                }}
              >
                {chartLabels[idx] || ""}
              </span>
            </div>
          );
        })}
      </div>

      {/* Value indicator */}
      <div
        style={{
          marginTop: "16px",
          paddingTop: "16px",
          borderTop: "1px solid #f1f5f9",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "12px", color: "#64748b" }}>
            Total this week
          </span>
          <span
            style={{ fontSize: "14px", fontWeight: "600", color: "#0f172a" }}
          >
            {new Intl.NumberFormat("id-ID", {
              style: "currency",
              currency: "IDR",
              minimumFractionDigits: 0,
            }).format(chartData.reduce((a, b) => a + b, 0) * 1000)}
          </span>
        </div>
      </div>
    </motion.div>
  );
}
